/* eslint-disable @typescript-eslint/no-shadow */
import { useEffect, useRef, useState } from 'react';

import ButtonElement from '@/components/elements/Button';
import Container from '@/components/elements/Container';
import Text from '@/components/elements/Text';
import { useStore } from '@/lib/store';

import Icon from '../../../assets/notification-icon.png';

function obj2Array(obj) {
  if (!obj) return [];
  return Object.keys(obj).map((k) => obj[k]);
}

const NOTIFICATION_LOCALSTORE = 'accepted_notifications';

export default function HeaderNotification(notifications) {
  const ref = useRef(null);
  const [accepted, setAccepted] = useState([]);
  const setNotificationHeight = useStore(
    ({ setNotificationHeight }) => setNotificationHeight
  );

  function dismissNotification(id) {
    const newAccepted = accepted.slice();
    newAccepted.push(id);
    localStorage.setItem(NOTIFICATION_LOCALSTORE, JSON.stringify(newAccepted));
    setAccepted(() => newAccepted);
  }

  function setProperty(property, value) {
    document.documentElement.style.setProperty(property, value);
  }

  useEffect(() => {
    const items = localStorage.getItem(NOTIFICATION_LOCALSTORE);
    if (items) {
      setAccepted(JSON.parse(localStorage.getItem(NOTIFICATION_LOCALSTORE)));
      setNotificationHeight('0px');
    }
  }, []);

  useEffect(() => {
    const notificationHeight = ref.current?.getBoundingClientRect().height;

    setNotificationHeight(notificationHeight);
    setProperty('--notification-height', `${notificationHeight}px`);
  }, [ref]);

  return (
    <div ref={ref}>
      {notifications.notifications.map((notification) => (
        <div
          key={notification.id}
          className={
            'bg-theme-gray-medium transition overflow-hidden duration-500 ease-in-out z-20 relative ring-1 ring-white/20 ' +
            `${accepted.includes(notification.id) ? 'h-0' : 'h-[auto]'}`
          }
        >
          <Container size="widest">
            <div className="flex flex-col place-content-center items-center gap-4 py-4 md:flex-row md:justify-between md:gap-6 md:py-4">
              <div className="flex items-center gap-2">
                <img src={Icon.src} alt="Alert:" className="size-8" />
                <Text size="base" color="white" className="items-center">
                  {notification.content.Description.content.reduce(
                    (a, b) =>
                      a + obj2Array(b.content).reduce((s, v) => s + (v.text ?? ''), ''),
                    ''
                  )}
                </Text>
              </div>
              <div className="w-full md:w-auto md:text-right">
                {notification.content.Destination && (
                  <ButtonElement
                    link={notification.content.Destination}
                    style={'primary'}
                    className="w-full md:w-auto"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="white"
                      className="-ml-1 mr-1 h-5 w-6"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z"
                        clipRule="evenodd"
                      />
                    </svg>
                    View Details
                  </ButtonElement>
                )}
              </div>
              {notification.content.Dismissible && (
                <button
                  onClick={() => dismissNotification(notification.id)}
                  className="text-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </button>
              )}
            </div>
          </Container>
        </div>
      ))}
    </div>
  );
}
